export default (pixels: number): string => `${pixels / 16}rem`;
